module.exports = __webpack_public_path__ + "32bcb53ade5ad9b5a8b595f9f48bb410.pdf";